/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import { DevtoolsBridgeProps } from '../devtools.types';

/**
 * Wrapper to expose the effective node as a separate fiber for devtools plus the
 * current effectiveState (the mutable, renderer-visible merged surface). DevTools
 * will prefer effectiveState over effectiveNode.properties when present.
 * No runtime behavior changes.
 */
export const DevtoolsBridge = ({ children }: DevtoolsBridgeProps) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>{children}</>
);
// eslint-disable-next-line no-underscore-dangle
DevtoolsBridge.__MASONRY_DEVTOOLS_BRIDGE__ = true;
